import { ChevronRight } from "@mui/icons-material";
import { Box, ButtonBase, Paper, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const CARD_RADIUS = 3;

/** Small, muted card heading so it reads below the card's content in the hierarchy. */
export function CardTitle({ icon, title }) {
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      spacing={0.75}
      sx={{ color: "text.secondary", "& svg": { fontSize: 16 } }}
    >
      {icon}
      <Typography variant="caption" fontWeight={600}>
        {title}
      </Typography>
    </Stack>
  );
}

/** Card with a title row and content, the whole card is a link when `to` is set. */
export default function LinkCard({ icon, title, to, testId, children }) {
  const clickable = Boolean(to);

  return (
    <Paper
      component={clickable ? ButtonBase : "div"}
      {...(clickable && { to, LinkComponent: Link })}
      data-testid={testId}
      sx={{
        p: 2,
        flex: 1,
        width: "100%",
        borderRadius: CARD_RADIUS,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textAlign: "left",
        transition: "background 0.15s ease",
        ...(clickable && { "&:hover": { bgcolor: "action.hover" } }),
      }}
    >
      <Box minWidth={0}>
        <CardTitle icon={icon} title={title} />
        <Stack direction={"row"} alignItems={"center"} spacing={1} mt={1}>
          {children}
        </Stack>
      </Box>
      {clickable ? (
        <ChevronRight sx={{ color: "text.disabled", flexShrink: 0 }} />
      ) : null}
    </Paper>
  );
}

export function getInitials(name) {
  if (!name) {
    return "?";
  }
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}
